import React from "react";

import { message } from "antd";

import { Link, Switch, Route } from "react-router-dom";

import { SessionStore, LocaleStore, RouterStore } from "@/stores";
import { inject, observer } from "mobx-react";
import "./index.less";
import MyIcon from "@/components/MyIcon";
import { project, dashboard } from "@/config.json";
import _ from "lodash";

interface Props {
  session: SessionStore;
  router: RouterStore;
  locale: LocaleStore;
}

@inject("session", "locale", "router")
@observer
class MineAddress extends React.Component<Props, any> {
  constructor(props) {
    super(props);
  }

  componentDidMount() {}

  render() {
    const { locale, session } = this.props;

    return (
      <div className="mine-address">
        <div className="title">
          {/* <MyIcon type="icon-address" className="icon-size" /> */}
          {locale.get("miner.address")}
        </div>

        <div>
          {_.keys(dashboard.minerList).map((region) => {
            const list = dashboard.minerList[region];
            const name = locale.get(`miner.${region}` as any, true);
            return (
              <div className="list" key={region}>
                <div className={`item-name ${!name && "zero-length"}`}>{name}</div>
                {list.map((name, index) => (
                  <div className="item-address" key={index}>
                    {name}
                  </div>
                ))}
              </div>
            );
          })}
        </div>
        <div className="list">
          <div>{locale.get("miner.example")}&nbsp;</div>
          <div>{project}.001</div>
        </div>
      </div>
    );
  }
}

export default MineAddress as React.ComponentType;
